// ============================================================================
// BOQ — Canonical trade chapters (shared)
// ============================================================================
// The SD estimate template seeds the canonical 11-trade structure (the
// brio_trade taxonomy top-level chapters). Both the Summary and the Bill of
// Quantities grid render those chapters numbered 1..N in taxonomy order — even
// chapters a project has no lines in yet — so the QS sees the whole catalogue
// at a glance and can tell what's missing.
//
// The Tender (TD) stage follows the same template: TD seeds mirror the SD rows,
// so a TD bill carries the same canonical `trade` labels and is organised the
// same way. DD / GFC work at item granularity and don't use the chapter model.
// ============================================================================

const CANONICAL_STAGES = new Set(['sd', 'td']);

// Returns the canonical top-level brio_trade chapters as
// [{ label, sortOrder }] in taxonomy sort order, or null when the stage
// doesn't use the chapter template or the taxonomy isn't loaded.
export function canonicalTradesFor(taxonomies, schemeStage) {
  if (!CANONICAL_STAGES.has(schemeStage)) return null;
  const brio = (taxonomies || []).find((t) => t.code === 'brio_trade');
  if (!brio) return null;
  return (brio.nodes || [])
    .filter((n) => !n.parentId)
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    .map((n) => ({ label: n.label, sortOrder: n.sortOrder }));
}

export default canonicalTradesFor;
